import React from 'react';
import '../styles/Footer.css';
import logo from '../logo-light.svg';

function Footer() {

    const links = [
        {
            url: "/pricing",
            text: "Pricing"
        },
        {
            url: "/terms-conditions",
            text: "Terms"
        },
        {
            url: "/login",
            text: "Login"
        },
        {
            url: "/privacy-policy",
            text: "Privacy"
        }
    ];

    return (
        <div className="footer-outer-container bg-colour-x-light">
            <div className="footer-inner-container">
                <div className="footer-top-container">
                    <div className="footer-left-container">
                        <img
                            src={logo}
                            className="footer-logo"
                            alt="Logo Light"
                        />
                        <span className="body-regular colour-primary">
                            Never run comps again.
                        </span>
                    </div>
                    <div className="footer-right-container">
                        <div className="footer-links-container">
                            {
                                links.map((item, index) =>
                                    <a 
                                        href={item.url}
                                        className="no-underline"
                                        key={index}
                                    >
                                        <span className="body-regular colour-primary cursor-pointer">
                                            {item.text}
                                        </span>   
                                    </a>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="footer-border-container margin-tops">
                </div>
                <div className="footer-bottom-container">
                    <div className="">
                        <a className="body-regular colour-primary no-underline" href="mailto:info@clozers.co">
                            info@clozers.co
                        </a>
                    </div>
                    <div className="">
                        <span className="body-regular colour-secondary">
                            © Coffee Clozers Inc. 2025
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Footer;